/**
 * Per-user memory of the chat composer's "Plain language" toggle (D2,
 * workspace docs/guardian/03 §3.3, 2026-10-22). Keyed by the signed-in
 * Guardian user id so one person's choice never leaks to another on a shared
 * device: a different user (or sign-out) reads their own key, not this one.
 * Every read/write goes through safeStorage, so a blocked/disabled store never
 * throws — the toggle just falls back to the department default in memory.
 */
import { safeStorage } from './safeStorage';

const KEY_PREFIX = 'guardian:plainLanguage:';

export function plainLanguageKey(userId) {
  return `${KEY_PREFIX}${userId || 'anon'}`;
}

/**
 * The user's own stored choice, or null when they have never set it (so the
 * caller can fall back to the department default).
 * @returns {boolean|null}
 */
export function readPlainLanguage(userId) {
  const raw = safeStorage.get(plainLanguageKey(userId));
  if (raw === 'true') return true;
  if (raw === 'false') return false;
  return null;
}

export function writePlainLanguage(userId, value) {
  return safeStorage.set(plainLanguageKey(userId), value ? 'true' : 'false');
}
